export default "__VITE_ASSET__DHzonxJ4__";